var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"overflow-x-hidden",attrs:{"title":"YouAuth – Advanced decentralized authentication | Youverse","transparent":true}},[_c('highlightSection',{attrs:{"backgroundImage":"/storage/images/products/youAuth/biometric_face_authentication.jpg","altImage":"Biometric Face Authentication","title":"Decentralized biometric authentication","subtitle":"Deliver secure and decentralized biometric authentication experiences to your customers.","leftButton":"See how it works","urlLeftButton":"https://6992654.fs1.hubspotusercontent-na1.net/hubfs/6992654/01.%20ONE%20PAGERS/Youverse_YouAuth.pdf","imageLeft":true}}),_vm._v(" "),_c('section2',{attrs:{"title":"Seamless and decentralized user authentication","elements":[
      {
        title: `Seamless and scalable authentication`,
        text: `YouAuth enables passwordless login, eliminating the frustration of forgotten passwords and reducing operational costs related to password resets. It's compatible with standard identity providers for easy integration with existing tech stacks.`,
      },
      {
        title: `Zero-trust authentication and liveness detection`,
        text: `YouAuth employs advanced liveness detection and fraud detection techniques to counter deepfake attacks and other sophisticated fraud attempts. With a decentralized, privacy-first data architecture, user data is never centralized or vulnerable to large-scale breaches.`,
      },
      {
        title: `Unparalleled performance and security`,
        text: `Top-tier NIST algorithms for unmatched security and reliability. 7x faster than standard encryption templates, delivering rapid authentication without compromising safety.`,
      },
    ]}}),_vm._v(" "),_c('div',{staticClass:"my-10"},[_c('cta',{attrs:{"title":"Get started","text":"See YouAuth in action and explore how it can fit your business needs.","buttonText":"Book a Demo","buttonLink":"/book-a-meeting","target":"_blank"}})],1),_vm._v(" "),_c('section3',{attrs:{"title":"See how YouAuth works in your industry","elements":[
      {
        title: `Banking`,
        text: `Accelerate onboarding, minimize fraud, and automate KYC/AML checks.`,
        seeMoreUrl: `/use-cases/banking`,
        imageSrc: `/storage/images/home/icons/banking.svg`,
        imageAlt: `Banking`,
        imageStyle: `w-20 h-20`,
      },
      {
        title: `iGaming`,
        text: `Simplify player verification, boost onboarding and ensure regulatory compliance.`,
        seeMoreUrl: `/use-cases/igaming`,
        imageSrc: `/storage/images/home/icons/igaming.svg`,
        imageAlt: `iGaming`,
        imageStyle: `w-20 h-20`,
      },
      {
        title: `Hospitality`,
        text: `Ensure operational efficiency, protect guests’ data, and eliminate check-in friction.`,
        seeMoreUrl: `/use-cases/hospitality`,
        imageSrc: `/storage/images/home/icons/hospitality.svg`,
        imageAlt: `Hospitality`,
        imageStyle: `w-20 h-20`,
      },
      {
        title: `Mobility`,
        text: `Onboard customers instantly, ensure robust driver’s verification, and gain your customers trust.`,
        seeMoreUrl: `/use-cases/mobility`,
        imageSrc: `/storage/images/home/icons/mobility.svg`,
        imageAlt: `Mobility`,
        imageStyle: `w-20 h-20`,
      },
    ]}}),_vm._v(" "),_c('PricingSection',{attrs:{"product-name":"web","title":"Simple, transparent pricing","description":"Choose the plan that fit your needs. Scale up at your pace."}},[_c('div',{staticClass:"lg:px-10 xl:px-14"},[_c('certificates')],1)]),_vm._v(" "),_c('latestPosts',{attrs:{"title":"Read our latest articles and resources","tags":['authentication']}}),_vm._v(" "),_c('div',{staticClass:"mt-28"},[_c('cta',{attrs:{"title":"Start your free trial today","text":"Explore YouAuth’s features at no cost and experience the difference firsthand.","buttonText":"Contact Us","buttonLink":"/company#contactus"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }